<template>
  <v-select
    clearable
    v-bind="$attrs"    
    :items="items"
    item-text="service"
    item-value="service_id"
    :label="`Only these ${ category || '' } Services`"
    placeholder="Any"
    :value="selected"
    return-object
    @input="selectChange"
  ></v-select>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: "ServiceSelect",

  props: {
    category: String,
    servicesPreloaded: Boolean,
    value: Object,
  },
  
  computed: {
    ...mapGetters('services', ['only_category', 'all']),

    selected() { 
      return this.value?.service_id
    },

    items() {
      let rval
      if (!this.category) {
        rval = [...this.all]
      } else {
        rval = [...this.only_category(this.category)] || []
      }

      return rval.sort( (a,b) => a.service.localeCompare(b.service) )
    },
  },

// .sort( (a,b) => a.service.localeCompare(b.service) )

  methods: {
    ...mapActions('services', ['loadAll']),

    selectChange(newVal) {
      this.$emit('input', newVal)
    },
  },

  created() {
    if (!this.servicesPreloaded) { 
      this.loadAll()
    }
  },
}
</script>